import { getApiMode } from '@/shared/lib/env';
import { setMode as setApiMode } from 'simpleloan_api';

setApiMode(getApiMode());
